<template>
    <div class="form-item">
        <div class="text-item" v-if="disabled">
            <span>Адрес парковки</span>
            <p>{{ data_address }}</p>
        </div>
        <div class="form-item" v-else>
            <label for="address">Адрес</label>
            <input ref="autocomplete" type="text" id="address" class="text-input _wide" v-model="data_address" />
        </div>
        <div class="inline form-item" valign="center">
            <label for="lat">Lat:</label>
            <input type="text" id="lat" class="text-input _medium" v-model="data_lat" disabled />
            <label for="lng">Lng:</label>
            <input type="text" id="lng" class="text-input _medium" v-model="data_lng" disabled />
        </div>
        <div>
            <div class="google-map" ref="googleMap"></div>
            <template v-if="Boolean(this.google) && Boolean(this.map)">
                <slot :google="google" :map="map" />
            </template>
        </div>
    </div>
</template>

<script>
    import GoogleMapsApiLoader from 'google-maps-api-loader'

    export default {
        props: ['address', 'lat', 'lng', 'disabled'],
        data () {
            return {
                data_address: this.address,
                data_lat: this.lat,
                data_lng: this.lng,
                google: null,
                map: null,
                mapConfig: {
                    center: {
                        lat: -34.6106621,
                        lng: -58.3665225
                    },
                    zoom: 11,
                    mapTypeControl: false,
                    streetViewControl: false,
                },
                apiKey: 'AIzaSyBsyIwnF7gK9mHeyJmMjlSovgTsl15KiAk',
                marker: false,
                autocomplete: false
            }
        },
        methods: {
            change () {
                this.$emit('update:lat', this.data_lat)
                this.$emit('update:lng', this.data_lng)
                this.$emit('update:address', this.data_address)
            },
            initializeMap() {
                let self = this
                const mapContainer = this.$refs.googleMap
                this.map = new this.google.maps.Map(
                    mapContainer, this.mapConfig
                )

                if (this.data_lat && this.data_lng) {
                    let latLng = {lat: parseFloat(this.data_lat), lng: parseFloat(this.data_lng)}
                    this.setMarker(latLng)
                    this.map.setCenter(latLng)
                }

                if (this.disabled) return false

                this.geocoder = new this.google.maps.Geocoder();

                this.map.addListener('click', function(e) {
                    self.data_lat = e.latLng.lat()
                    self.data_lng = e.latLng.lng()
                    self.change()
                    let latLng = {lat: self.data_lat, lng: self.data_lng}
                    self.setMarker(latLng)

                    self.geocoder.geocode({location: latLng}, (results, status) => {
                            if (status === "OK") {
                                if (results[0]) {
                                    self.data_address = self.getPlaceName(results[0].address_components)
                                    self.$emit('update:address', self.data_address)
                                }
                            } else {
                                window.alert("Geocoder failed due to: " + status);
                            }
                        }
                    );
                })


                this.autocomplete = new this.google.maps.places.Autocomplete(this.$refs.autocomplete, {
                    types: ['geocode'],
                    componentRestrictions: {
                        country: 'ar'
                    }
                })

                this.autocomplete.addListener('place_changed', () => {
                    let place = self.autocomplete.getPlace()
                    self.data_address = this.getPlaceName(place.address_components)
                    self.data_lat = place.geometry.location.lat()
                    self.data_lng = place.geometry.location.lng()
                    let latLng = {lat: self.data_lat, lng: self.data_lng}
                    self.map.setCenter(latLng)
                    self.setMarker(latLng)
                    self.change()
                })
            },
            setMarker (latLng) {
                if (this.marker) this.marker.setMap(null)
                this.marker = new this.google.maps.Marker({
                    position: latLng,
                    map: this.map
                })
            },
            getPlaceName (address_components) {
                let postal = '',
                    street = '',
                    route = '',
                    locality = '',
                    administrative = ''
                let result = []
                for (let item of address_components) {
                    if (item.types[0] == 'street_number') street = item.long_name
                    if (item.types[0] == 'route') route = item.long_name
                    if (item.types[0] == 'postal_code') postal = item.long_name
                    if (item.types[0] == 'locality') locality = item.long_name
                    if (item.types[0] == 'administrative_area_level_1') administrative = item.long_name
                }

                if (street) result.push(street)
                if (route) result.push(route)
                if (postal) result.push(postal)
                if (locality) result.push(locality)
                if (administrative) result.push(administrative)

                return result.join(', ')
            }
        },
        async mounted() {
            const googleMapApi = await GoogleMapsApiLoader({
                apiKey: this.apiKey,
                libraries: ['places'],
                language: 'es'
            })

            this.google = googleMapApi
            this.initializeMap()
        }
    }
</script>